import Constants from "./constants";
import Utils from "./utils";
const dayjs = require("dayjs");

const chartUtils = {
  baseColumns: [
    {
      prop: "workout_record_start_time",
      label: "date",
      formatter: (row) =>
        `${Utils.formatDateTime(row.workout_record_start_time)} - ${Utils.formatTime(row.workout_record_end_time)}`,
      width: 120,
    },
    {
      prop: "name",
      label: "name",
      formatter: (row) =>
        `${row.user && row.user.length > 0 ? row.user[0].name : ""}`,
      width: 240,
    },
    {
      prop: "workout_exercise_duration",
      label: "duration",
      formatter: (row, col, cell) => Utils.formatDuration(cell),
      width: 110,
    },
    {
      prop: "workout_hr_abs_peak_min",
      label: "min HR",
      formatter: (row, col, cell) => `${cell} bpm`,
      width: 100,
    },
    {
      prop: "workout_hr_abs_peak_max",
      label: "max HR",
      formatter: (row, col, cell) => `${cell} bpm`,
      width: 100,
    },
  ],
  baseColumnsExtras: [
    {
      prop: "workout_record_calorie",
      label: "calories",
      formatter: (row, col, cell) => `${cell} kcal`,
      width: 120,
    },
    {
      prop: "strain",
      label: "strain (0-21)",
      width: 220,
    },
  ],
  columnHeaders: [
    {
      workoutType: [
        Constants.WORKOUT_TYPE_ID.OUTDOOR_WALK,
        Constants.WORKOUT_TYPE_ID.INDOOR_WALK,
        Constants.WORKOUT_TYPE_ID.OUTDOOR_RUN,
        Constants.WORKOUT_TYPE_ID.INDOOR_RUN,
      ],
      values: [
        {
          prop: "workout_record_distance",
          label: "distance",
          formatter: (row) =>
            `${Utils.formatDistance(row.workout_record_distance)} km`,
          width: 110,
        },
        {
          prop: "workout_record_speed",
          label: "avg speed",
          formatter: (row) =>
            `${Utils.formatSpeed(row.workout_record_distance, row.workout_exercise_duration)} km/h`,
          width: 120,
        },
        {
          prop: "avg_pace",
          label: "avg pace",
          formatter: (row) => `${Utils.formatPace(row.avg_pace)} /km`,
          width: 110,
        },
        {
          prop: "fastest_pace",
          label: "fastest pace",
          formatter: (row) => `${Utils.formatPace(row.fastest_pace)} /km`,
          width: 130,
        },
        // {
        //   prop: "avg_cadence",
        //   label: "avg cadence",
        //   formatter: (row) => `${row.avg_cadence} steps/min`,
        //   width: 135,
        // },
      ],
    },
    {
      workoutType: [
        Constants.WORKOUT_TYPE_ID.ELLIPTICAL,
        Constants.WORKOUT_TYPE_ID.INDOOR_CYCLE,
        Constants.WORKOUT_TYPE_ID.OTHER,
      ],
      values: [],
    },
    {
      workoutType: [Constants.WORKOUT_TYPE_ID.ROWER],
      values: [
        {
          prop: "workout_record_step",
          label: "strokes",
          width: 160,
        },
      ],
    },
    {
      workoutType: [Constants.WORKOUT_TYPE_ID.JUMP_ROPE],
      values: [
        {
          prop: "workout_record_step",
          label: "jumps",
          width: 100,
        },
        {
          prop: "longest_streak",
          label: "longest streak",
          width: 100,
        },
        {
          prop: "tripped",
          label: "tripped",
          width: 100,
        },
      ],
    },
    {
      workoutType: [Constants.WORKOUT_TYPE_ID.POOL_SWIM],
      values: [
        {
          prop: "workout_record_distance",
          label: "distance",
          formatter: (row) =>
            `${Utils.formatDistance(row.workout_record_distance)} km`,
        },
        {
          prop: "swim_pull_times",
          label: "strokes",
        },
        {
          prop: "swim_pull_rate",
          label: "avg strokes rate",
          formatter: (row) => `${row.swim_pull_rate} /min`,
        },
        {
          prop: "swim_trip_times",
          label: "tripped",
          formatter: (row) => `${row.swim_trip_times} time(s)`,
        },
        {
          prop: "swim_avg_swolf",
          label: "swolf",
        },
        {
          prop: "swim_type",
          label: "style",
          formatter: (row) => Utils.getSwimMainStroke(row.swim_type),
        },
      ],
    },
  ],
  getColumnHeaders(workoutType) {
    let columnHeaders = [...this.baseColumns, ...this.baseColumnsExtras];
    this.columnHeaders.map((record) => {
      const found = record.workoutType.find((w) => w == workoutType);
      if (found > 0) {
        columnHeaders = [
          ...this.baseColumns,
          ...record.values,
          ...this.baseColumnsExtras,
        ];
      }
    });
    return columnHeaders;
  },
  sectionColor(sectionName) {
    let randomColor = "#fff";
    if (sectionName && sectionName.length > 0)
      return Utils.stringToHexColor(sectionName);
    return randomColor;
  },
  average(ctx, datasetIndex) {
    const values = ctx.chart.data.datasets[datasetIndex].data;
    const nonZeroValues = values.filter((v) => v > 0);

    if (nonZeroValues.length > 0)
      return values.reduce((a, b) => a + b, 0) / nonZeroValues.length;
    return 0;
  },
  dataRangesChart(dataRanges) {
    let chart = {
      labels: [],
      datasets: [],
    };

    let rows = dataRanges;
    if (rows && rows.length > 0) {
      // Filter for unique days to use as chart labels (x-axis)
      let chartLabels = (dataRangesRecords) => {
        let uniqueDays = [
          ...new Set(dataRangesRecords.map((element) => element.bucket)),
        ];
        return uniqueDays;
      };

      chart.labels = chartLabels(rows).map((record) => [
        dayjs(record).format(Constants.CHART_DATE_FORMAT),
        dayjs(record).format(Constants.CHART_DATE_DAY_OF_WEEK_FORMAT),
      ]);

      // Filter for unique sections to use as chart datasets (y-axis)
      let chartSections = (dataRangesRecords) => {
        let uniqueSections = [
          ...new Set(dataRangesRecords.map((element) => element.section_name)),
        ];
        return uniqueSections;
      };

      chartSections(rows).map((section) => {
        let sectionRows = rows.filter((r) => r.section_name == section);
        let sectionData = [];
        // We need [[section1_day1_min, section1_day1_max], [section1_day2_min, section1_day2_max, [...]]
        // format to for each day (for the chart)
        sectionRows.map((sr) => {
          sectionData.push([parseFloat(sr.min), parseFloat(sr.max)]);
        });

        chart.datasets.push({
          label: section.toUpperCase(), // section_name
          data: sectionData,
        });
      });
    }
    return chart;
  },
  scoreRangesChart(dataRanges, colorCodes) {
    // dashboard
    let chart = {
      labels: [],
      datasets: [],
    };

    let rows = dataRanges;
    let sleepData = [];
    let recoveryData = [];
    let strainData = [];
    if (rows && rows.length > 0) {
      rows.map((row) => {
        chart.labels.push(row.section_name);
        sleepData.push([row.min_sleep_score, row.max_sleep_score]);
        recoveryData.push([row.min_recovery_score, row.max_recovery_score]);
        strainData.push([row.min_strain, row.max_strain]);
      });

      chart.datasets.push(
        {
          label: "Sleep Score",
          data: sleepData,
          color: colorCodes["sleep"],
        },
        {
          label: "Recovery Score",
          data: recoveryData,
          color: colorCodes["recovery"],
        },
        {
          label: "Strain",
          data: strainData,
          color: colorCodes["strain"],
        }
      );
    }
    return chart;
  },
  sleepHoursChart(dataSleepHours, colorSleep) {
    let chart = {
      labels: [],
      datasets: [],
    };

    let rows = dataSleepHours;
    if (rows && rows.length > 0) {
      let dataAvgRemSleepMinutes = [];
      let dataAvgDeepSleepMinutes = [];
      let dataAvgLightSleepMinutes = [];
      let dataAvgAwakeMinutes = [];
      let dataAvgSleepScore = [];

      rows.map((row) => {
        chart.labels.push(row.user[0].name);
        dataAvgRemSleepMinutes.push(row.avg_rem_sleep_minutes);
        dataAvgDeepSleepMinutes.push(row.avg_deep_sleep_minutes);
        dataAvgLightSleepMinutes.push(row.avg_light_sleep_minutes);
        dataAvgAwakeMinutes.push(row.avg_awake_minutes);
        dataAvgSleepScore.push(row.avg_sleep_score);
      });

      chart.datasets.push(
        {
          label: "REM Sleep",
          data: dataAvgRemSleepMinutes,
          backgroundColor: colorSleep["rem"],
        },
        {
          label: "Deep Sleep",
          data: dataAvgDeepSleepMinutes,
          backgroundColor: colorSleep["deep"],
        },
        {
          label: "Light Sleep",
          data: dataAvgLightSleepMinutes,
          backgroundColor: colorSleep["light"],
        },
        {
          label: "Awake",
          data: dataAvgAwakeMinutes,
          backgroundColor: colorSleep["awake"],
        },
        {
          label: "Average Sleep Score",
          data: dataAvgSleepScore,
        }
      );
    }
    return chart;
  },
  avgRecoveryAndHrvChart(dataAvgRecoveryAndHrv) {
    let chart = {
      labels: [],
      datasets: [],
    };

    if (dataAvgRecoveryAndHrv && dataAvgRecoveryAndHrv.length > 0) {
      let recoveryScoreRange = [];
      let avgHrv = [];

      dataAvgRecoveryAndHrv.map((record) => {
        chart.labels.push(record.user[0].name);
        recoveryScoreRange.push([
          record.min_recovery_score,
          record.max_recovery_score,
        ]);
        avgHrv.push(record.avg_hrv);
      });

      chart.datasets.push(
        {
          label: "RECOVERY SCORE (%)",
          data: recoveryScoreRange,
        },
        {
          label: "AVG HRV (MS)",
          data: avgHrv,
        }
      );
    }
    return chart;
  },
  avgRhrChart(dataAvgRecoveryAndHrv) {
    let chart = {
      labels: [],
      datasets: [],
    };

    if (dataAvgRecoveryAndHrv && dataAvgRecoveryAndHrv.length > 0) {
      let rhrRange = [];

      dataAvgRecoveryAndHrv.map((record) => {
        chart.labels.push(record.user[0].name);
        rhrRange.push([record.min_rhr, record.max_rhr]);
      });

      chart.datasets.push({
        label: "RHR (BPM)",
        data: rhrRange,
      });
    }
    return chart;
  },
  avgMaxHrChart(dataStrainAvgMaxHr) {
    let chart = {
      labels: [],
      datasets: [],
    };

    if (dataStrainAvgMaxHr && dataStrainAvgMaxHr.length > 0) {
      let maxHrRange = [];
      let avgCalories = [];

      dataStrainAvgMaxHr.map((record) => {
        chart.labels.push(record.user[0].name);
        maxHrRange.push([record.min_hr, record.max_hr]);
        avgCalories.push(record.avg_calories);
      });

      chart.datasets.push(
        {
          label: "MAX HR (BPM)",
          data: maxHrRange,
        },
        {
          label: "AVG CALORIES (KCAL)",
          data: avgCalories,
        }
      );
    }
    return chart;
  },
};

export default chartUtils;
